import axios from "axios";
import { OpenAPI } from "./core/OpenAPI";
import { getValidAccessToken, forceLogout } from "./authToken";

/**
 * Wires token handling into the whole app. Imported once from index.tsx.
 *
 * - The OpenAPI client resolves its bearer token through getValidAccessToken(),
 *   so every generated ApiService call automatically gets a fresh (refreshed
 *   if needed) token.
 * - A global axios 401 interceptor is the reactive safety net: any request that
 *   still comes back 401 (e.g. a token revoked server-side) logs the user out.
 */
OpenAPI.TOKEN = async () => (await getValidAccessToken()) || "";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url: string = error?.config?.url || "";
    // Don't bounce on the auth endpoints themselves (bad login / refresh).
    const isAuthCall =
      url.includes("/accounts/login") || url.includes("/refresh_token");
    if (status === 401 && !isAuthCall) {
      forceLogout();
    }
    return Promise.reject(error);
  }
);

export {};
